import { useQuery } from '@tanstack/react-query';

import { eventJournalApi } from '@entities/eventJournal/api';
import { useGetAllQueryParams } from '@entities/eventJournal/lib/hooks';

export const useGetJournalEventsListForCustomerQuery = (isCustomer: boolean) => {
    const { adaptedQueryParams } = useGetAllQueryParams();
    const {
        data: dataForCustomer,
        isSuccess,
        isPending,
        isLoading,
    } = useQuery({
        ...eventJournalApi.getJournalEventsListForCustomerQueryOptions({
            queryParams: adaptedQueryParams,
            isEnable: isCustomer,
        }),
    });

    return {
        dataForCustomer,
        isSuccess,
        isPending,
        isLoading,
    };
};
